// extracted by mini-css-extract-plugin
export default {"proAdvertisementWrap":"acotrs_proAdvertisementWrapEvkEL","bodyWrap":"acotrs_bodyWrapqoAhx","topUpgrade":"acotrs_topUpgradeyC1Ck","ratingRequest":"acotrs_ratingRequestioR4l"};